import { storeShape } from './PropTypes';
export default {
  name: 'StoreProvider',
  props: {
    store: storeShape.isRequired
  },
  provide: function provide() {
    return {
      storeContext: this.$props
    };
  },
  render: function render() {
    return this.$slots['default'][0];
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/_ant-design-vue@1.7.3@ant-design-vue/es/_util/store/Provider.js
// module id = null
// module chunks = 